<script setup>
import NavLink from "@/Components/NavLink.vue";
import {route} from "ziggy-js";
import {computed} from "vue";
import {usePage} from "@inertiajs/vue3";
import {LOCALES} from "@/constants.js";

const page = usePage();
const rate = computed(() => {
    if (page.props.lang === LOCALES.RU) {
        return page.props.roblox_rates?.rub ?? '1,5';
    } else {
        return page.props.roblox_rates?.usd ?? 120;
    }
});
</script>
<template>
    <NavLink
        :href="route('roblox.index')"
        class="flex relative overflow-hidden glare-link bg-gradient-to-l from-[#0C0F1F] to-[#0284C7] grow max-h-[52px] cursor-pointer dark:bg-black justify-center lg:justify-between shrink-0 p-2 px-10 items-center gap-2 transition-colors shadow-sm rounded-lg">
        <img alt="Gold Robux" src="/assets/icons/gold-rbx.svg"/>
        <div class="grow text-center max-w-fit font-condensed font-medium lg:max-w-full text-white text-base">
            {{$t('ROBUX CHEAP: 1$ = 120 ROBUX', {amount: rate})}}
        </div>
    </NavLink>
<!--    <NavLink-->
<!--        :href="route('prize-draw')"-->
<!--        class="flex relative overflow-hidden glare-link bg-gradient-to-l from-[#0C0F1F] to-[#0284C7] grow max-h-[52px] cursor-pointer dark:bg-black justify-center lg:justify-between shrink-0 p-2 items-center gap-2 transition-colors shadow-sm rounded-lg">-->
<!--        <img alt="prize-box" style="width:52px; height: 52px" src="/assets/img/prize-draw/popups/info/box.webp">-->
<!--        <div class="grow text-center max-w-fit lg:max-w-full text-white text-sm">-->
<!--            <span>{{$t('Daily Free Giveaway')}}</span>-->
<!--        </div>-->
<!--    </NavLink>-->
</template>

<style>
.glare-link::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 1.5em;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    transform: translateX(-4em) skewX(-45deg);
    animation: move-light;
    animation-duration: 5s;
    animation-iteration-count: infinite;
    animation-delay: 1s;
}

@keyframes move-light {
    0% {
        transform: translateX(-4em) skewX(-45deg);
    }
    50% {
        transform: translateX(30em) skewX(-45deg);
        background-color: transparent;
    }
    100% {
        background-color: transparent;
    }
}
</style>
